import { ExportTransportTypes } from 'constants/exportTypes';
import { NOTIFICATIONS_REFETCH_INTERVAL, NotificationTypes } from 'constants/notifications';

import { useQuery } from '@tanstack/react-query';
import { NotificationsResponse, getNotifications } from 'config/requests/notifications';
import { getUnixTime, subDays } from 'date-fns';

type UseGetNotificationsReturnValue = {
  notifications?: NotificationsResponse;
  isLoading: boolean;
  refetch: () => void;
};

const DEFAULT_NOTIFICATIONS_PAGINATION = {
  page: 1,
  perPage: 10000,
};

export function useGetNotifications(isEnabled: boolean): UseGetNotificationsReturnValue {
  const getRequestParams = () => ({
    createdAt: { gte: getUnixTime(subDays(new Date(), 2)), lte: getUnixTime(new Date()) },
    'transports.transport': ExportTransportTypes.Admin,
    notificationType: [
      NotificationTypes.Report,
      NotificationTypes.OrderAdjustment,
      NotificationTypes.CommissionRecalculationTasks,
      NotificationTypes.Reconciliation,
    ],
    order: { id: 'DESC' },
    ...DEFAULT_NOTIFICATIONS_PAGINATION,
  });

  const {
    data: notifications,
    isLoading,
    refetch,
  } = useQuery<NotificationsResponse>({
    queryKey: ['notifications'],
    queryFn: () => getNotifications(getRequestParams()),
    enabled: isEnabled,
    refetchInterval: NOTIFICATIONS_REFETCH_INTERVAL,
  });

  return { notifications, isLoading, refetch };
}
